import { render, staticRenderFns } from "./Fixed Width Page.vue?vue&type=template&id=050e52df&"
import script from "./Fixed Width Page.vue?vue&type=script&lang=js&"
export * from "./Fixed Width Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIHeader: require('/opt/build/repo/components/UI/Header.vue').default,UIFooter: require('/opt/build/repo/components/UI/Footer.vue').default})
